import {
  Description,
  DescriptionProps,
} from "Features/CheckPrice/Products/Advice/adviceStyled";

import styled from "styled-components";

export const AdviceIntroDesc = styled(Description)<DescriptionProps>`
  margin-top: 0;
`;

export const AdviceMessageStyle = styled.div`
  margin: 24px 0;
`;
